import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { announceToScreenReader } from '../../utils/a11y.utils';

const ROUTE_TITLES = {
	'/': 'Manage consent login',
	'/fip': 'Manage consent login',
	'/entity-selection': 'Choose consents to manage',
	'/revoke-consent': 'Manage consents',
	'/status': 'Consent action status',
	'/consent-details': 'Consent details',
	'/fiu-consent-details': 'Consent details',
};

const RouteAnnouncer = () => {
	const location = useLocation();
	const isFirstRenderRef = useRef(true);

	useEffect(() => {
		const pageTitle = ROUTE_TITLES[location.pathname] || 'Finvu Revoke Consent';
		document.title = `${pageTitle} | Finvu`;
		announceToScreenReader(`Navigated to ${pageTitle}`);

		// Skip on initial mount so we don't steal focus from the page's own
		// autofocus targets (e.g. OTP input) on first load.
		if (isFirstRenderRef.current) {
			isFirstRenderRef.current = false;
			return;
		}

		window.scrollTo(0, 0);

		const rafId = requestAnimationFrame(() => {
			const mainContent = document.getElementById('main-content');
			mainContent?.focus({ preventScroll: true });
		});

		return () => cancelAnimationFrame(rafId);
	}, [location.pathname]);

	return null;
};

export default RouteAnnouncer;
